module.exports = __webpack_public_path__ + "img/cp.3776198d.svg";